import ArticleCookingClassHero from './ArticleCookingClassHero'

export default ArticleCookingClassHero